export default {
    url: '/all?page&keyword&metaSearch&questionPoolId&categoryId&createdBy&sort&externalId',
    template: '<ui-view></ui-view>',
    abstract: true
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/questions/all/index.js